<div class="container" style="padding-top: 20px;">
<h4 mat-dialog-title *ngIf="calledFrom == 'home'">{{'Contact Reporter'| translate }}</h4>
<h4 mat-dialog-title *ngIf="calledFrom == 'menu'">{{'Contact Reporter'| translate }}</h4>
<div class="profile-form new-profil" #scrollMe>
  <form [formGroup]="ReportForm" (ngSubmit)="onSubmit()">
    <div *ngIf="!this.petDetail.GDPRStatus">
      <div class="form-group align-items-center">
        <label class="col-sm-3 col-form-label required-star">{{ 'Name' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <input type="text" class="form-control-plaintext" value="" formControlName="Name" minlength="3" maxlength="25"
            [ngClass]="{'is-invalid':submitted && r.Name.errors}">
          <div *ngIf="submitted && r.Name.errors" class="invalid-feedback">
            <div *ngIf="r.Name.errors.required">{{'Name is required' | translate}}</div>
            <div *ngIf="r.Name.errors.minlength">{{'Name is of more then 3 char'| translate}}</div>
            <div *ngIf="r.Name.errors.maxlength">{{'Name is not more then 25 char'| translate}}</div>
            <div *ngIf="r.Name.errors.whitespace && !r.Name.errors.required">{{'Space is not allowed'|
              translate}}</div>
          </div>
        </div>
      </div>
      <div class="form-group align-items-center">
        <label class="col-sm-3 col-form-label">{{ 'Email' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <input type="text" pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" class="form-control-plaintext"
            value="" formControlName="EmailId" minlength="3" maxlength="25"
            [ngClass]="{'is-invalid':submitted && r.EmailId.errors}">
          <div *ngIf="submitted && r.EmailId.errors" class="invalid-feedback">
            <div *ngIf="r.EmailId.errors.pattern">{{'Please Enter a valid Email-ID'| translate}}</div>
            <div *ngIf="r.EmailId.errors.whitespace && !r.EmailId.errors.required">{{'Space is not allowed'|
              translate}}</div>
          </div>
        </div>
      </div>
      <div class="form-group align-items-center">
        <label class="col-sm-3 col-form-label required-star">{{ 'Phone No.' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <input type="text" class="form-control-plaintext" value="" formControlName="MobileNumber" minlength="5"
            maxlength="10" [ngClass]="{'is-invalid':submitted && r.MobileNumber.errors}">
          <div *ngIf="submitted && r.MobileNumber.errors" class="invalid-feedback">
            <div *ngIf="r.MobileNumber.errors.required">{{'Phone Number is required' | translate}}</div>
            <div *ngIf="r.MobileNumber.errors.minlength">{{'Phone Number is of more then 5 char'| translate}}</div>
            <div *ngIf="r.MobileNumber.errors.maxlength">{{'Phone Number is not more then 10 char'| translate}}</div>
            <div *ngIf="r.MobileNumber.errors.whitespace && !r.MobileNumber.errors.required">{{'Space is not allowed'|
              translate}}</div>
          </div>
        </div>
      </div>
      <div #box class="result-box" style="overflow-y: auto;"></div>
      <div class="form-group align-items-center">
        <label class="col-sm-3 col-form-label">{{ 'Text' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <textarea class="form-control" id="exampleFormControlTextarea1" formControlName="Description"
            (focus)="onfocus()" rows="3"></textarea>
        </div>
      </div>
      <div class="form-check align-items-center col-12 mb-4">
        <input type="checkbox" class="form-check-input" value="1" id="exampleCheck1" formControlName="IsTermsAccepted"
          [ngClass]="{'is-invalid':submitted && r.IsTermsAccepted.errors}">
        <a class="chkbx-terms" for="exampleCheck1" href="javascript:void(0)" (click)="open(tandc)" target="blank">{{
          'Accept terms and conditions' | translate }}</a>
        <div *ngIf="submitted && r.IsTermsAccepted.errors" class="invalid-feedback">
          <div *ngIf="r.IsTermsAccepted.errors.required">{{'Please accept terms and conditions'| translate}}</div>
          <div *ngIf="r.IsTermsAccepted.errors.checked && !r.IsTermsAccepted.errors.required">{{'Please accept terms
            and
            conditions'| translate}}</div>
        </div>
      </div>
      <div mat-dialog-actions>
        <button type="submit" class="btn btn-primary mr-3">{{ 'Submit' | translate
          }}</button>
        <button class="btn btn-secondary cancelaccpt " mat-button (click)="CloseDialogPopup()">{{ 'Cancel' | translate
          }}</button>
      </div>
    </div>
    <div *ngIf="this.petDetail.GDPRStatus && this.IsCompany">
      <div class="form-group align-items-center mb-0">
        <label class="col-sm-5 ">{{ 'Owner Email' | translate }}</label>
        <div class="col-sm-7 form-input-side">
          <label value="" formControlName="EmailId" title="this.emailAddress" class="emailidlbl"> <a
              href="mailto:{{this.emailAddress}}">
              {{this.emailAddress}}</a></label>
        </div>
      </div>
      <div class="form-group align-items-center">
        <label class="col-sm-5">{{ 'Owner Phone No.' | translate }}</label>
        <div class="col-sm-7 form-input-side">
          <label (click)="openPhoneDialer(this.phoneNumber)" value="" formControlName="MobileNumber" class="phonenumber"> {{this.phoneNumber}}</label>          
        </div>
      </div>
      <div mat-dialog-actions>
        <button class="btn btn-secondary cancel-contactbtn" mat-button (click)="CloseDialogPopup()">{{ 'Cancel' |
          translate }}</button>
      </div>
    </div>
    <div *ngIf="this.petDetail.GDPRStatus && !this.IsCompany">
      <div class="form-group align-items-center mb-0">
        <label class="col-sm-3 ">{{ 'Email' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <label value="" formControlName="EmailId" title="this.emailAddress" class="emailidlbl"> <a
              href="mailto:{{this.emailAddress}}">
              {{this.emailAddress}}</a></label>
        </div>
      </div>
      <div class="form-group align-items-center">
        <label class="col-sm-3">{{ 'Phone No.' | translate }}</label>
        <div class="col-sm-9 form-input-side">
          <label (click)="openPhoneDialer(this.phoneNumber)" value="" formControlName="MobileNumber" class="phonenumber"> {{this.phoneNumber}}</label>          
        </div>
      </div>
      <div mat-dialog-actions>
        <button class="btn btn-secondary cancel-contactbtn" mat-button (click)="CloseDialogPopup()">{{ 'Cancel' |
          translate }}</button>
      </div>
    </div>
  </form>
  <div id="actionButton"></div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{''| translate}} </p>
</ngx-spinner>
<div class="tandc">
  <ng-template #tandc let-modal>

    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{'Terms and Conditions'| translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center col-md-12">
        <h2>BRUKERVILKÅR FOR SAVNET OG FUNNET</h2>
        <p>De følgende brukervilkårene regulerer din tilgang til og bruk av tjenesten Savnet og Funnet ("Tjenesten").
          Tjenesten leveres av DyreID AS. Ved å trykke aksepter bekrefter du at du har lest og godtar disse vilkårene.
          <br />

          Ved vesentlige endringer av vilkårene vil du få varsel sendt til din registrerte epostadresse innen rimelig
          tid
          før de nye endringene trer i kraft.
        </p>

        <h4>1. OM TJENESTEN</h4>
        <p>Tjenesten er en løsning som tilbys av DyreID AS for at savnede kjæledyr lettere skal kunne finnes. Tjenesten
          gir privatpersoner, organisasjoner og andre relevante aktører ("Brukerne") adgang til å annonsere dyr som
          savnet
          eller funnet via DyreIDs Savnet og Funnet-kanaler.<br />

          Du kan registrere deg for Tjenesten ved å opprette en Savnet og Funnet-bruker her. Dersom du allerede har
          opprettet en Min Side-bruker hos DyreID, kan du registrere deg via din eksisterende brukerprofil. Du kan også
          logge deg inn på Tjenesten via sosiale medier (Facebook, Google og andre relevante kanaler).</p>
        <h4>2 BRUK AV SAVNET OG FUNNET</h4>
        <p>Tjenesten benyttes på eget ansvar. Dersom man benytter seg av Tjenesten i strid med disse vilkårene eller
          brukerens bruk eller misbruk ellers medfører ulemper for DyreID, kan DyreID kreve erstatning for sine tap.
          <br />

          DyreID tar ikke ansvar for innhold som lagres eller distribueres via Tjenesten. DyreID forbeholder seg retten
          til å fjerne eller nekte å distribuere innhold på Tjenestene, samt å si opp Brukere som ikke overholder
          brukervilkårene. Ved å godkjenne disse vilkårene forplikter du deg til å ikke laste opp bilder eller tekst som
          har et upassende innhold (f.eks. seksualiserende eller støtende innhold). <br />

          Brukere som registrerer dyret sitt i Tjenesten må oppgi riktige opplysninger om navn, adresse, telefonnummer
          og
          andre nødvendige opplysninger. Brukere som legger inn uriktige eller manglende opplysninger, kan risikere å få
          dyret fjernet fra listen over savnede dyr. <br />

          Brukerne er ansvarlige for å holde status på dyreannonsen løpende oppdatert. En annonse vil bli markert som
          "løst" eller "gjenforent" dersom Brukeren (i) ikke har endret status på dyret eller utvidet savnet-perioden
          innen 28 dager fra datoen annonsen ble registrert, eller (ii) selv har markert eller rapportert at dyret er
          funnet.
        </p>
        <h4>3 PERSONVERN</h4>
        <p>I forbindelse med bruken av Tjenesten vil DyreID behandle personopplysninger om Brukerne. Denne behandlingen
          er
          nærmere beskrevet i DyreIDs personvernerklæring.</p>
        <h4>4 KOMMUNIKASJON MED BRUKERNE</h4>
        <p>Du kan selv velge om du vil tilgjengeliggjøre din egen kontaktinformasjon når du legger ut en annonse i
          Tjenesten. Hvis du ikke velger å tilgjengeliggjøre kontaktinformasjonen din, vil all kommunikasjon mellom deg
          og
          andre Brukere gå via DyreID. DyreID er ikke ansvarlig for innholdet i kommunikasjonen som videreformidles i
          denne forbindelse. <br />

          Brukere som ønsker å respondere på en savnet-annonse og rapportere inn et dyr som funnet, må enten bruke
          kontaktskjemaet som ligger i Tjenesten eller den publiserte kontaktinformasjonen til den Brukeren som har
          annonsert dyret som savnet. Av sikkerhetshensyn vil IP-adresser bli logget i forbindelse med kommunikasjon med
          Brukerne av Tjenesten.</p>
      </div>
    </div>

  </ng-template>
</div>
</div>